require('angular/customer/app/ApplicationCtrl.coffee');
require('angular/libs/avant/customer_applications/controllers');
require('angular/customer/contracts/ContractCtrl.coffee');
require('angular/libs/avant/controllers/LoginModalCtrl.coffee');
